"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaAppTemplateDataGridSx = exports.RaTextFieldSx = exports.RaAppEditorDataGridSx = exports.RaMetadataDataGridSx = exports.RaOAuth2ClientDataGridSx = exports.RaEventsDataGridSx = exports.RaMediaLibraryDataGridSx = exports.RaAppIntegrationDataGridSx = exports.RaIntegrationDataGridSx = exports.RaEventLogDataGridSx = exports.RaTeamsUsersDataGridSx = exports.RaInvitationsDataGridSx = exports.RaTeamsDataGridSx = exports.RaDataGridSx = exports.RaMetadataDatagridTheme = exports.RaDatagridTeamsTheme = exports.RaDatagridTheme = exports.ExportButtonTheme = exports.RaPaperTheme = exports.RaPaginationTheme = exports.RaSelectInputTheme = exports.RaTeamsFilterInputTheme = exports.RaSearchInputTheme = void 0;
var styles_1 = require("@mui/material/styles");
var KeyboardArrowDownRounded_1 = __importDefault(require("@mui/icons-material/KeyboardArrowDownRounded"));
var ExpandMoreRounded_1 = __importDefault(require("@mui/icons-material/ExpandMoreRounded"));
var NavigateBeforeRounded_1 = __importDefault(require("@mui/icons-material/NavigateBeforeRounded"));
var NavigateNextRounded_1 = __importDefault(require("@mui/icons-material/NavigateNextRounded"));
exports.RaSearchInputTheme = (0, styles_1.createTheme)({
    components: {
        MuiTextField: {
            defaultProps: {
                variant: "standard",
            },
            styleOverrides: {
                root: {
                    width: "360px",
                    background: "white",
                    boxShadow: "5px 0px 10px #2C27380A",
                    borderRadius: "4px",
                    top: "-6px",
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: "var(--primary-color)",
                },
            },
        },
        MuiInput: {
            defaultProps: {
                placeholder: "Search",
            },
            styleOverrides: {
                root: {
                    marginTop: "0px !important",
                    height: "37px",
                    border: "var(--ns-border)",
                    borderRadius: "4px",
                    fontFamily: "var(--bs-body-font-family)",
                    color: "var(--info-color)",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    "&:before": {
                        border: 0,
                    },
                    "&:after": {
                        border: 0,
                    },
                    "&:hover:not(.Mui-disabled)::before": {
                        border: 0,
                    },
                },
                input: {
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    "&:placeholder": {
                        fontFamily: "var(--bs-body-font-family)",
                    },
                },
            },
        },
    },
});
exports.RaTeamsFilterInputTheme = (0, styles_1.createTheme)({
    components: {
        MuiTextField: {
            defaultProps: {
                variant: "standard",
            },
            styleOverrides: {
                root: {
                    width: "360px",
                    background: "white",
                    boxShadow: "5px 0px 10px #2C27380A",
                    borderRadius: "4px",
                    marginTop: "20px !important",
                    marginBottom: "20px"
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: "var(--primary-color)",
                },
            },
        },
        MuiInput: {
            defaultProps: {
                placeholder: "Search",
            },
            styleOverrides: {
                root: {
                    marginTop: "0px !important",
                    height: "37px",
                    border: "var(--ns-border)",
                    borderRadius: "4px",
                    fontFamily: "var(--bs-body-font-family)",
                    color: "var(--info-color)",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    "&:before": {
                        border: 0,
                    },
                    "&:after": {
                        border: 0,
                    },
                    "&:hover:not(.Mui-disabled)::before": {
                        border: 0,
                    },
                },
                input: {
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    "&:placeholder": {
                        fontFamily: "var(--bs-body-font-family)",
                    },
                },
            },
        },
    },
});
exports.RaSelectInputTheme = (0, styles_1.createTheme)({
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({ fontFamily: "var(--bs-body-font-family)", fontSize: "13px", color: "var(--info-color)" }, (ownerState.selected === true && {
                        backgroundColor: "var(--hover-color) !important",
                        "&:hover": {
                            backgroundColor: "var(--lightgray-color) !important",
                        },
                    })));
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontFamily: "var(--bs-body-font-family)",
                    fontSize: "13px",
                    color: "var(--info-color)",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                notchedOutline: {
                    border: 0,
                },
                input: {
                    padding: "0px 0px",
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                IconComponent: KeyboardArrowDownRounded_1.default,
            },
            styleOverrides: {
                icon: {
                    color: "var(--primary-color)",
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: 0,
                    lineHeight: 0,
                    margin: 0,
                },
            },
        },
    },
});
exports.RaPaginationTheme = (0, styles_1.createTheme)({
    components: {
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    color: "var(--info-color)",
                    font: "var(--bs-body-font-family)",
                    marginTop: "12px",
                },
                input: {
                    font: "var(--bs-body-font-family)",
                    paddingRight: "12px !important",
                },
                selectLabel: {
                    font: "var(--bs-body-font-family) !important",
                    display: "flex",
                    alignItems: "center",
                    margin: "0px",
                },
                selectIcon: {
                    color: "var(--info-color)",
                    margin: "0 16px",
                },
                select: {
                    font: "var(--bs-body-font-family) !important",
                    display: "flex",
                    color: "var(--info-color)",
                    justifyContent: "center",
                    border: "var(--ns-border)",
                    background: "white",
                    height: "37px",
                    width: "40px",
                    borderRadius: "4px",
                },
                displayedRows: {
                    font: "var(--bs-body-font-family)",
                    display: "flex",
                    alignItems: "center",
                    justifyItems: "center",
                    height: "37px !important",
                    margin: "0 12px 0 0",
                },
                actions: {
                    font: "var(--bs-body-font-family)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0px",
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    color: "var(--info-color)",
                    backgroundColor: "white",
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    height: "37px !important",
                },
            },
        },
        MuiMenu: {
            styleOverrides: {
                root: {
                    borderRadius: "4px",
                },
            },
        },
        MuiList: {
            styleOverrides: {
                root: {
                    paddingTop: "0px",
                    paddingBottom: "0px",
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    font: "var(--bs-body-font-family)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "var(--info-color)",
                    "&:hover": {
                        backgroundColor: "var(--secondary-color)",
                    },
                    "&.Mui-selected": {
                        font: "var(--bs-body-font-family)",
                        color: "var(--secondary-color)",
                        backgroundColor: "var(--info-color)",
                        "&:hover": {
                            color: "var(--secondary-color)",
                            backgroundColor: "var(--info-color)",
                        },
                        "&.Mui-focusVisible": {
                            color: "var(--secondary-color)",
                            background: "var(--info-color)",
                            "&:hover": {
                                color: "var(--secondary-color)",
                                backgroundColor: "var(--info-color)",
                            },
                        },
                    },
                },
            },
        },
        MuiSelect: {
            defaultProps: {
                variant: "outlined",
                IconComponent: ExpandMoreRounded_1.default,
            },
            styleOverrides: {
                select: {
                    display: "flex",
                    alignItems: "center",
                    font: "var(--bs-body-font-family) !important",
                    height: "37px !important",
                    width: "54px",
                    backgroundColor: "white",
                    padding: "0px",
                    borderRadius: "4px",
                    "&.MuiSelect-nativeInput": {
                        height: "37px !important",
                    },
                },
            },
        },
        MuiPagination: {
            defaultProps: {
                shape: "rounded",
                variant: "outlined",
                boundaryCount: 0,
                siblingCount: 0,
            },
            styleOverrides: {
                root: {
                    font: "var(--bs-body-font-family)",
                    color: "var(--info-color)",
                    display: "flex",
                    alignContent: "center",
                    "&.MuiPagination-outlined": {
                        border: "var(--ns-border)",
                        backgroundColor: "white",
                        borderRadius: "4px",
                    },
                },
            },
        },
        MuiSvgIcon: {
            defaultProps: {
                fontSize: "large",
            },
            styleOverrides: {
                root: {
                    "&.MuiPaginationItem-icon": {
                        color: "var(--info-color)",
                    },
                },
            },
        },
        MuiPaginationItem: {
            defaultProps: {
                size: "large",
                variant: "text",
                components: {
                    previous: NavigateBeforeRounded_1.default,
                    next: NavigateNextRounded_1.default,
                },
            },
            styleOverrides: {
                root: {
                    font: "var(--bs-body-font-family) !important",
                    color: "var(--info-color)",
                    backgroundColor: "white",
                    display: "flex",
                    justifyItems: "center",
                    margin: "0px",
                    borderRadius: "0px",
                    border: "none",
                    height: "37px",
                    width: "60px",
                    "&.MuiPaginationItem-ellipsis": {
                        display: "none",
                    },
                    "&:hover": {
                        height: "37px",
                        color: "var(--info-color)",
                        backgroundColor: "var(--secondary-color)",
                    },
                    "&:active": {
                        height: "37px",
                        color: "var(--secondary-color)",
                        backgroundColor: "var(--info-color)",
                        ".MuiPaginationItem-icon": {
                            color: "var(--secondary-color) !important",
                        },
                    },
                    "&.MuiPaginationItem-icon": {
                        height: "37px",
                        fontSize: "large !important",
                    },
                    "&.Mui-selected": {
                        height: "37px",
                        color: "var(--secondary-color)",
                        backgroundColor: "var(--info-color)",
                    },
                    "&.Mui-selected:hover": {
                        backgroundColor: "var(--info-color)",
                    },
                },
                icon: {
                    fontSize: "2.1875rem !important",
                },
                previousNext: {
                    color: "red !important",
                    "&:hover": {
                        "&.MuiPaginationItem-icon": {
                            color: "var(--secondary-color) !important",
                        },
                    },
                    "&:active": {
                        "&.MuiPaginationItem-icon": {
                            color: "var(--secondary-color) !important",
                        },
                    },
                },
            },
        },
    },
});
exports.RaPaperTheme = (0, styles_1.createTheme)({
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: "Geomanist-Bold",
                    fontSize: "13px",
                    color: "var(--info-color)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "130px",
                },
            },
        },
    },
});
exports.ExportButtonTheme = (0, styles_1.createTheme)({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.Mui-disabled": {
                        color: "gray",
                        "& .MuiSvgIcon-root": {
                            color: "gray",
                        },
                    },
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: "var(--info-color)",
                    marginRight: "-5px",
                },
            },
        },
    },
});
exports.RaDatagridTheme = (0, styles_1.createTheme)({
    components: {
        MuiTableSortLabel: {
            defaultProps: {
                IconComponent: KeyboardArrowDownRounded_1.default,
            },
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.active == true && {
                        color: "var(--info-color) !important",
                    })));
                },
                icon: {
                    color: "var(--primary-color) !important",
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    fontFamily: "var(--bs-body-font-family)",
                    width: "102px",
                    height: "23px",
                    background: "var(--secondary-color)",
                    borderRadius: "4px",
                    marginRight: "10px",
                    color: "var(--info-color)",
                    fontSize: "13px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    paddingTop: "2px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "&:hover": {
                        color: "var(--info-color)",
                    },
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.checked == true && {
                        color: "var(--primary-color) !important",
                    })));
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    marginTop: "-65px",
                    background: "#FFF",
                    borderRadius: "14px",
                    boxShadow: "6px 0px 18px #0000000F",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: "unset",
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: "var(--bs-body-font-family)",
                    color: "var(--info-color)",
                    whiteSpace: "nowrap",
                },
            },
        },
    },
});
exports.RaDatagridTeamsTheme = (0, styles_1.createTheme)({
    components: {
        MuiTableSortLabel: {
            defaultProps: {
                IconComponent: KeyboardArrowDownRounded_1.default,
            },
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.active == true && {
                        color: "var(--info-color) !important",
                    })));
                },
                icon: {
                    color: "var(--primary-color) !important",
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    fontFamily: "var(--bs-body-font-family)",
                    width: "102px",
                    height: "23px",
                    background: "var(--secondary-color)",
                    borderRadius: "4px",
                    marginRight: "10px",
                    color: "var(--info-color)",
                    fontSize: "13px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    paddingTop: "2px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "&:hover": {
                        color: "var(--info-color)",
                    },
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.checked == true && {
                        color: "var(--primary-color) !important",
                    })));
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    background: "#FFF",
                    borderRadius: "14px",
                    boxShadow: "6px 0px 18px #0000000F",
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: "standard",
            },
            styleOverrides: {
                root: {
                    width: "360px",
                    background: "white",
                    boxShadow: "5px 0px 10px #2C27380A",
                    borderRadius: "4px",
                    top: "-6px",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: "unset",
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: "var(--bs-body-font-family)",
                    color: "var(--info-color)",
                    whiteSpace: "nowrap",
                },
            },
        },
    },
});
exports.RaMetadataDatagridTheme = (0, styles_1.createTheme)({
    components: {
        MuiTableSortLabel: {
            defaultProps: {
                IconComponent: KeyboardArrowDownRounded_1.default,
            },
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.active == true && {
                        color: "var(--info-color) !important",
                    })));
                },
                icon: {
                    color: "var(--primary-color) !important",
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    fontFamily: "var(--bs-body-font-family)",
                    width: "102px",
                    height: "23px",
                    background: "var(--secondary-color)",
                    borderRadius: "4px",
                    marginRight: "10px",
                    color: "var(--info-color)",
                    fontSize: "13px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    paddingTop: "2px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    "&:hover": {
                        color: "var(--info-color)",
                    },
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.checked == true && {
                        color: "var(--primary-color) !important",
                    })));
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    marginTop: "-65px",
                    background: "#FFF",
                    borderRadius: "14px",
                    boxShadow: "6px 0px 18px #0000000F",
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: "unset",
                    textAlign: "left",
                    "&:first-of-type": {
                        width: "10%",
                        textAlign: "center"
                    },
                    "&:nth-of-type(2)": {
                        width: "40%",
                    },
                    "&:nth-of-type(3)": {
                        width: "40%",
                    },
                    "&:last-of-type": {
                        width: "10%",
                        textAlign: "right"
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontFamily: "var(--bs-body-font-family)",
                    color: "var(--info-color)",
                    whiteSpace: "nowrap",
                },
            },
        },
    },
});
exports.RaDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "75px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: "20px",
    },
    "& .RaDatagrid-row:last-child .RaDatagrid-rowCell:last-of-type": {
        textAlign: "right",
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaDatagrid-clickableRow": {
        cursor: "pointer"
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaTeamsDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaDatagrid-rowCell:last-child": {
        width: "60px"
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaInvitationsDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "20px"
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "300px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "100px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaDatagrid-rowCell:last-child": {
        width: "60px"
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaTeamsUsersDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        width: "195px",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaEventLogDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type, & .RaDatagrid-rowCell:first-of-type": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        minWidth: "90px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(2), & .RaDatagrid-rowCell:nth-of-type(2)": {
        minWidth: "140px",
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaIntegrationDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "100px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "47px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "300px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaAppIntegrationDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "100px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "1000px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
        "& .MuiTableCell-root:last-child": {
            textAlign: "right",
        },
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaMediaLibraryDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "100px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        maxWidth: 0,
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "1080px",
        minWidth: "250px"
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        width: "230px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(4)": {
        width: "230px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(5)": {
        width: "180px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
    "& .MuiTableCell-root.MuiTableCell-body.MuiTableCell-sizeSmall.column-undefined.RaDatagrid-rowCell": {
        textAlign: "right",
    }
};
exports.RaEventsDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "100px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "47px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        width: "280px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(4)": {
        width: "150px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(5)": {
        width: "150px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(6)": {
        width: "150px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(7)": {
        width: "360px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(8)": {
        width: 0,
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaOAuth2ClientDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaDatagrid-rowCell:last-child": {
        width: "60px"
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaMetadataDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
        textAlign: "left",
        width: "33.33%",
    },
    "& .RaDatagrid-headerRow": {
        height: "100px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px 0 0 0",
        textAlign: "center"
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "0 14px 0 0",
        textAlign: "right"
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
        textAlign: "center !important",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    },
};
exports.RaAppEditorDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "100px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        width: "350px",
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(4)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(5)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(6)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(7)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(8)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        width: "60px",
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    }
};
exports.RaTextFieldSx = {
    fontFamily: "Geomanist",
    color: "var(--info-color)",
    fontSize: "13px",
};
exports.RaAppTemplateDataGridSx = {
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--close-btn-color)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "100px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        width: "350px",
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(4)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(5)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(6)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(7)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(8)": {
        width: "200px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        width: "60px",
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    },
    "& .RaBulkActionsToolbar-toolbar": {
        visibility: "hidden",
    },
    "& .RaImageField-image": {
        height: "unset",
    }
};
